import Toolbar from "../../shared-components/Toolbar";
import { Button, Space, Table, TableProps } from "antd";
import { useQuery } from "react-query";
import { fetchDPendingItems } from "../../queries/orderQueriesV2";
import { IOrderedItem } from "@drone-parts.garphild.pro/interfaces";
import { useState } from "react";
import dayjs from "dayjs";

function PendingItems() {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const { refetch, status, data: pendingItems } = useQuery(
    ["pendingItems", { page: 1, pageSize: 10 }],
    fetchDPendingItems,
    {
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 5,
      onSuccess: (data) => {
        console.log("data", data);
      }
    }
  );

  const rowSelection: TableProps<IOrderedItem>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: IOrderedItem[]) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedItems(selectedRows.map((item) => item._id!));
    },
    getCheckboxProps: (record: IOrderedItem) => ({
      disabled: false,
      name: record._id,
    }),
  };

  return (
    <Space direction="vertical">
      <Toolbar>
        <Button
          onClick={() => {
            refetch();
          }}
          loading={status === "loading"}
        >
          Refresh
        </Button>
      </Toolbar>
      <Space>
        <Table
          columns={[
            {
              title: "Marketplace",
              dataIndex: "marketplaceId",
              key: "marketplaceId",
            },
            {
              title: "Status",
              dataIndex: "orderStatus",
              key: "orderStatus",
            },
            {
              title: "Name",
              dataIndex: "shortName",
              key: "shortName",
            },
            {
              title: "Order Date",
              dataIndex: "orderDate",
              key: "orderDate",
              render: (value) => dayjs(value).format("YYYY-MM-DD"),
            },
            {
              title: "Tracking Numbers",
              dataIndex: "trackingNumbers",
              key: "trackingNumbers",
              render: (value, row) => {
                return value?.map((trackingNumber: string) => (
                  row.marketplaceId === 'aliexpress' && (
                    <>
                      <a
                        href={`https://www.aliexpress.com/p/tracking/index.html?tradeOrderId=${row.orderNumber}`}
                        key={trackingNumber}
                        target="_blank"
                      >
                        {trackingNumber}
                      </a>
                      <br />
                    </>
                )));
              },
            },
            {
              title: "Qty",
              dataIndex: "inStock",
              key: "inStock",
              render: (value, row) => {
                return `${value} / ${row.itemQuantity}`;
              }
            },
          ] as TableProps<IOrderedItem>['columns']}
          rowKey={(record) => record._id!}
          rowSelection={{ type: 'checkbox', ...rowSelection }}
          dataSource={pendingItems?.data || []}
        />
      </Space>
    </Space>
  );
}

export default PendingItems;
